/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TTLOOrderValue {
    Supplier = 'Supplier',
    Carrier = 'Carrier',
    BrandAndMarket = 'BrandAndMarket',
    Channel = 'Channel',
    FareType = 'FareType',
    Relevance = 'Relevance',
    OffsetDays = 'OffsetDays',
    OverrideDays = 'OverrideDays'
}

export function TTLOOrderValueFromJSON(json: any): TTLOOrderValue {
    return TTLOOrderValueFromJSONTyped(json, false);
}

export function TTLOOrderValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLOOrderValue {
    return json as TTLOOrderValue;
}

export function TTLOOrderValueToJSON(value?: TTLOOrderValue | null): any {
    return value as any;
}

